import axios from "axios";
import { OptionsPack } from "../../Models/Pack/PackModels"
import { URL_MIDIS, URLAPI } from "../../Setting";
import { errorService } from "../Error/ErrorService";

export function OptionsPackService(){
    return{
        async getOptionsPack(token:string){
            let options:OptionsPack[]=[];
            try {
                const response = await axios.get(`${URLAPI+'optionsPack'}`, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                      "Content-Type":"application/ld+json"
                    },
                });
                const data = response.data['hydra:member'];
                for(const opt of data){
                    options.push({
                        id:opt['id'],
                        nom:opt['nom'],
                        valeur:opt['valeur'],
                        typeMessage:opt['typeMessage'],
                        "@id":opt['@id']
                    })
                }
            } catch (error) {
                errorService().handleError('Erreur lors du getOptionsPackFromURLSToPack', error)
                return [];
            }
            return options;
        },

        async getOptionsPackFromURLSToPack(urls:string[],token:string){
            let options:OptionsPack[]=[];
            if(urls.length>0){
                for(const url of urls){
                    try {
                        const response = await axios.get(`${URL_MIDIS+url}`, {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                "Content-Type":"application/ld+json"
                            },
                        });
                        const data = response.data['hydra:member'];
                        if(data.length>0){
                            options.push({
                                id:data[0]['id'],
                                nom:data[0]['nom'],
                                valeur:data[0]['valeur'],
                            });
                        }
                    } catch (error) {
                        errorService().handleError('Erreur lors du getOptionsPackFromURLSToPack', error)
                        return [];
                    }
                }
            }
            return options;
        }
    }
}